import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";

const BASE_URL = packageJson.apiUrl;
const SITE_URL = packageJson.siteUrl;

const CourseFilter = ({ onCategoryChange, onSearchResults }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}/category/list`);
        const data = await response.json();
        if (data.success) {
          setCategories(data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.length >= 3) {
        fetch(`https://app.endorselearning.co.uk/api/courselist?name=${searchTerm}`)
          .then((res) => res.json())
          .then((data) => {
            if (onSearchResults) {
              onSearchResults(data);
            }
          })
          .catch((err) => console.error("Search fetch error:", err));
      }
    }, 500); // debounce delay

    return () => clearTimeout(delayDebounce); // cleanup
  }, [searchTerm]);

  const handleCheckboxChange = (e, categoryId) => {
    let updatedCategories = [...selectedCategories];
    if (e.target.checked) {
      updatedCategories.push(categoryId);
    } else {
      updatedCategories = updatedCategories.filter((id) => id !== categoryId);
    }
    setSelectedCategories(updatedCategories);
    onCategoryChange(updatedCategories);
  };

  return (
    <div className="filter-card">
      <div className="filter-srch mb-3">
        <i className="bi bi-search"></i>
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold d-block mb-2">Category</label>
        {categories.map((category) => (
          <div className="form-check mb-2" key={category.id}>
            <input
              className="form-check-input"
              type="checkbox"
              value={category.id}
              id={`category${category.id}`}
              onChange={(e) => handleCheckboxChange(e, category.id)}
            />
            <label
              className="form-check-label"
              htmlFor={`category${category.id}`}
            >
              {category.category}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseFilter;
